import React from 'react'
import ReactDOM from 'react-dom'

import { Router, browserHistory } from 'react-router'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import { CreateJumpstateMiddleware, Actions } from 'jumpstate'
import PiwikReactRouter from 'piwik-react-router'
import rootReducer from './rootReducer'
import setAuthorizationToken from './utils/setAuthorizationToken'

import routes from './routes'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-rtl/dist/css/bootstrap-rtl.css'
import 'font-awesome/css/font-awesome.min.css'
import 'animate.css/animate.min.css'

const routingMiddleware = routerMiddleware(browserHistory)

const initialState = window.__REDUX_STATE__
window.__BROWSER_ENV__ = true
window.__PROTOCOL__ = process.env.NODE_ENV === 'production' ? 'https' : 'http'

const store = createStore(
  rootReducer,
  initialState,
  compose(applyMiddleware(CreateJumpstateMiddleware(), routingMiddleware), window.devToolsExtension && (process.env.NODE_ENV !== 'production') ? window.devToolsExtension() : f => f)
)

const piwik = PiwikReactRouter({
  url: 'https://piwik.iaho.ir',
  siteId: 1
})

const history = syncHistoryWithStore(browserHistory, store)

if (window.localStorage.auth) {
  const auth = JSON.parse(window.localStorage.auth)
  setAuthorizationToken(auth.token)
  Actions.logged_in(auth)
  Actions.loadNewHorse()
  Actions.userInfo()
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={piwik.connectToHistory(history)} routes={routes} />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js